import { render, staticRenderFns } from "./CPP_PptReactionsCopy2.vue?vue&type=template&id=6b2dd508&scoped=true&"
import script from "./CPP_PptReactionsCopy2.vue?vue&type=script&lang=js&"
export * from "./CPP_PptReactionsCopy2.vue?vue&type=script&lang=js&"
import style0 from "./CPP_PptReactionsCopy2.vue?vue&type=style&index=0&id=6b2dd508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2dd508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VSelect})
